import { withNavigationWatcher } from "./contexts/navigation";

import {
  HomePage3,
  ProfilePage,
  CardPage,
  DogovorPage /*DotsPage,*/,
  DogovorActionsPage,
  EnergoobjectsPage,
  FinDocsPage,
  PaysPage,
  PokazaniaEditPage,
  PokazaniaUK,
  PokazaniaHistoryPage,
  AccountDetailPage,
  ConsumptionAnalysisPage,
  ConsumptionHistoryPage,
  LettersPage,
  AgregatorCalculator,
  AgregatorEvents,
  AddDogovorPage,
  HelpPage,
  AdministrationPage,
  DebtPage,
  AgregatorReclamePage,
  AuditPageLogs,
  AuditPageStats,
  AddDogovorTatenergosbytPage,
  EditDogovorPage,
  TerminateDogovorPage,
  FixPricePage,
  AdministrationPanelPage,
  GoIsuPage,
  AdminImpersonationPage,
  TechConnectionPage,
  RangeVolumesPage,
  BudgetPage, AddContractPage, ChangeContractPage, DelContractPage,
  RangeVolumesHistoryPage,
  AddDogovorExtPage,
  AdminOtherPage
} from "./pages";
import EcpPageTest from "./pages/ecp/ecp-page-test";
import Planning from "./pages/planning/planning";
import AnalizPlanning from "./pages/analiz-planning/analiz-planning";
import AnalizPrice from "./pages/analiz-price/analiz-price";
import PriceEnergy from "./pages/price-energy/price-energy";
import AdminMaintenancePage from "./pages/audit/admin-maintenance/admin-maintenance";

const routes = [
  {
    path: "/card",
    component: CardPage,
    title: "Лицевая карта",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/dogovor",
    component: DogovorPage,
    title: "Информация о договоре",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },{
    path: "/budget",
    component: BudgetPage,
    title: "Бюджетный потребитель",
    sd_visible: false,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/budget/add-contract",
    component: AddContractPage,
    title: "Бюджетный потребитель",
    sd_visible: false,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/budget/change-contract",
    component: ChangeContractPage,
    title: "Бюджетный потребитель",
    sd_visible: false,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/budget/del-contract",
    component: DelContractPage,
    title: "Бюджетный потребитель",
    sd_visible: false,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/dogovor-actions",
    component: DogovorActionsPage,
    title: "Информация о договоре",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/add-dogovor",
    component: AddDogovorPage,
    title: "Заключить договор",
    sd_visible: false,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/edit-dogovor",
    component: EditDogovorPage,
    title: "Изменить договор",
    sd_visible: true,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/tech-connection",
    component: TechConnectionPage,
    title: "Технологическое присоединение",
    sd_visible: true,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/go-isu",
    component: GoIsuPage,
    title: "Изменить договор",
    sd_visible: true,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/terminate-dogovor",
    component: TerminateDogovorPage,
    title: "Расторгнуть договор",
    sd_visible: true,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/add-dogovor/tat",
    component: AddDogovorTatenergosbytPage,
    title: "Заключить договор/контракт",
    sd_visible: false,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/energoobjects",
    component: EnergoobjectsPage,
    title: "Объекты и точки поставки",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/planning",
    component: Planning,
    title: "Подача заявок",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/analiz-planning",
    component: AnalizPlanning,
    title: "Анализ планирования",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/price-analysis",
    component: AnalizPrice,
    title: "Анализ ценовых параметров",
    sd_visible: false,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/docs",
    component: FinDocsPage,
    title: "Финансовые документы",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/account-detail",
    component: AccountDetailPage,
    title: "Детализация начислений",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/pays",
    component: PaysPage,
    title: "Оплаты",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/pokazania-new",
    component: PokazaniaEditPage,
    title: "Передать показания",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/pokazania-uk",
    component: PokazaniaUK,
    title: "Передать показания",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/pokazania-history",
    component: PokazaniaHistoryPage,
    title: "История показаний",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/consumption-analysis",
    component: ConsumptionAnalysisPage,
    title: "Анализ потребления",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/consumption-history",
    component: ConsumptionHistoryPage,
    title: "История потребления",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/price-energy",
    component: PriceEnergy,
    title: "Цена на электроэнергию текущего расчетного периода",
    sd_visible: true,
    all_users_visible: false,
    sd_agr_visible: false,
  },
  {
    path: "/profile",
    component: ProfilePage,
    title: "Профиль",
    sd_visible: false,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  // {
  //   path: '/home2',
  //   component: HomePage2,
  //   title: 'Главная',
  //   sd_visible: false,
  //   all_users_visible: true,
  //   sd_agr_visible: false
  // },
  {
    path: "/home",
    component: HomePage3,
    title: "Главная",
    sd_visible: false,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/letters",
    component: LettersPage,
    title: "Обращения",
    sd_visible: true,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/ecp-page-test",
    component: EcpPageTest,
    title: "Тест ЭЦП",
    sd_visible: false,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/agregator-reclame",
    component: AgregatorReclamePage,
    title: "Управление спросом",
    sd_visible: false,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/agregator-events",
    component: AgregatorEvents,
    title: "События",
    sd_visible: false,
    all_users_visible: false,
    sd_agr_visible: true,
  },
  {
    path: "/agregator-calculator",
    component: AgregatorCalculator,
    title: "Калькулятор эффективности",
    sd_visible: false,
    all_users_visible: true,
  },
  {
    path: "/help",
    component: HelpPage,
    title: "Техническая поддержка",
    sd_visible: false,
    all_users_visible: true,
  },
  {
    path: "/admin-panel",
    component: AdministrationPanelPage,
    title: "Панель администратора",
  },
  {
    path: "/admin",
    component: AdministrationPage,
    title: "Управление доступом",
    sd_visible: true,
    all_users_visible: false,
  },
  {
    path: "/audit-stats",
    component: AuditPageStats,
    title: "Статистика посещений",
  },
  {
    path: "/audit-log",
    component: AuditPageLogs,
    title: "Аудит пользователей",
  },
  {
    path: "/admin-impersonation",
    component: AdminImpersonationPage,
    title: "Вход под пользователем",
  },
  {
    path: "/admin-maintenance",
    component: AdminMaintenancePage,
    title: "Управление сервисным режимом",
  },
  {
    path: "/admin-other",
    component: AdminOtherPage,
    title: "Прочее",
  },
  {
    path: "/debt",
    component: DebtPage,
    title: "Задолженность",
    sd_visible: true,
    all_users_visible: false,
  },
  {
    path: "/fix-price",
    component: FixPricePage,
    title: "Фиксированная цена",
    sd_visible: true,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/range-volumes-edit",
    component: RangeVolumesPage,
    title: "Приложение 32",
    sd_visible: true,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/range-volumes-history",
    component: RangeVolumesHistoryPage,
    title: "Приложение 32. История",
    sd_visible: true,
    all_users_visible: true,
    sd_agr_visible: false,
  },
  {
    path: "/add-dogovor/ext",
    component: AddDogovorExtPage,
    title: "Заключить договор/контракт",
    sd_visible: false,
    all_users_visible: true,
    sd_agr_visible: false,
  },
];

export default routes.map((route) => {
    return {
        ...route,
        component: withNavigationWatcher(route.component),
    };
});
